import script from "./UserPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPicker.vue?vue&type=script&setup=true&lang=js"

import "./UserPicker.vue?vue&type=style&index=0&id=61c1b066&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61c1b066"]])

export default __exports__